const corporateBrochure = {
  // page.tsx
  'corporateBrochure.page.lastUpdated': 'Last updated: 5 July 2026',
  'corporateBrochure.page.backToTop': 'Back to top',
  'corporateBrochure.page.homeLink': 'Home',
  'corporateBrochure.page.corporateLink': 'Corporate Training',
  'corporateBrochure.page.currentPage': 'Corporate Brochure Request',

  // JSON-LD
  'corporateBrochure.jsonld.serviceName': 'On-Site Corporate Training Brochure Request',
  'corporateBrochure.jsonld.orgName': 'The All Japan Butler Association',
  'corporateBrochure.jsonld.serviceType': 'Corporate hospitality training brochure request',
  'corporateBrochure.jsonld.areaServed': 'Japan',
  'corporateBrochure.jsonld.description': 'Request our corporate brochure covering on-site and academy-based training programmes, pricing, and delivery process.',
  'corporateBrochure.jsonld.breadcrumb1': 'Home',
  'corporateBrochure.jsonld.breadcrumb2': 'Corporate Training',
  'corporateBrochure.jsonld.breadcrumb3': 'Corporate Brochure Request',

  // HeroSection
  'corporateBrochure.hero.homeLink': 'Home',
  'corporateBrochure.hero.corporateLink': 'Corporate Training',
  'corporateBrochure.hero.currentPage': 'Corporate Brochure Request',
  'corporateBrochure.hero.title': 'Corporate On-Site Training Brochure Request',
  'corporateBrochure.hero.titleEn': 'CORPORATE BROCHURE REQUEST',
  'corporateBrochure.hero.lead': 'Request our corporate brochure covering on-site and academy-based training programmes, pricing, and the delivery process. We will send a confirmation email after you submit the form.',
  'corporateBrochure.hero.imgAlt': 'A Japanese butler instructor guiding hospitality gestures during a corporate training session',

  // Contents
  'corporateBrochure.contents.label': 'DOCUMENT CONTENTS',
  'corporateBrochure.contents.title': "What's Inside",
  'corporateBrochure.contents.subtitleEn': "What's Inside",
  'corporateBrochure.contents.lead': 'The corporate brochure includes the following content.',
  'corporateBrochure.contents.0.title': 'Six Training Modules',
  'corporateBrochure.contents.0.titleEn': 'SIX TRAINING MODULES',
  'corporateBrochure.contents.0.desc': 'Details of all six modules, including deportment, VIP guest handling, and tea & table service',
  'corporateBrochure.contents.1.title': 'Industry-Specific Programmes',
  'corporateBrochure.contents.1.titleEn': 'INDUSTRY PROGRAMMES',
  'corporateBrochure.contents.1.desc': 'Sample programmes for 8 industries including hotels, finance, and healthcare',
  'corporateBrochure.contents.2.title': 'Pricing Plans',
  'corporateBrochure.contents.2.titleEn': 'PRICING PLANS',
  'corporateBrochure.contents.2.desc': 'Details of half-day, full-day, and ongoing programme pricing',
  'corporateBrochure.contents.3.title': 'On-Site Delivery Flow',
  'corporateBrochure.contents.3.titleEn': 'ON-SITE DELIVERY FLOW',
  'corporateBrochure.contents.3.desc': 'The process from enquiry through needs assessment, on-site delivery, and reporting',
  'corporateBrochure.contents.4.title': 'About the Association',
  'corporateBrochure.contents.4.titleEn': 'ABOUT THE ASSOCIATION',
  'corporateBrochure.contents.4.desc': 'Introduction to the All Japan Butler Association and our instructors',
  'corporateBrochure.contents.notice': 'The brochure is sent by email as a PDF. If you would prefer postal delivery, please note this in the message field.',

  // Form
  'corporateBrochure.form.label': 'REQUEST FORM',
  'corporateBrochure.form.title': 'Corporate Brochure Request Form',
  'corporateBrochure.form.subtitleEn': 'Corporate Brochure Request',
  'corporateBrochure.form.lead': 'Please complete the form below and submit. We will send a confirmation email after you submit the form.',
  'corporateBrochure.form.noHardSell': 'Requesting the brochure is free. We will not contact you excessively if you have not requested it. Please feel free to apply.',
  'corporateBrochure.form.company': 'Company Name',
  'corporateBrochure.form.company.placeholder': 'e.g. ABC Corporation',
  'corporateBrochure.form.company.error': 'Company name is required',
  'corporateBrochure.form.department': 'Department / Title',
  'corporateBrochure.form.department.placeholder': 'e.g. HR, Training Manager',
  'corporateBrochure.form.name': 'Contact Person',
  'corporateBrochure.form.name.placeholder': 'e.g. Taro Butler',
  'corporateBrochure.form.name.error': 'Contact person name is required',
  'corporateBrochure.form.email': 'Email Address',
  'corporateBrochure.form.email.placeholder': 'e.g. taro@example.com',
  'corporateBrochure.form.email.error': 'Email address is required',
  'corporateBrochure.form.email.invalid': 'Please enter a valid email address',
  'corporateBrochure.form.phone': 'Phone Number',
  'corporateBrochure.form.phone.placeholder': 'e.g. 090-1234-5678',
  'corporateBrochure.form.industry': 'Industry',
  'corporateBrochure.form.industry.error': 'Please select an industry',
  'corporateBrochure.form.industry.select': 'Please select',
  'corporateBrochure.form.industry.hotel': 'Hotels & Inns',
  'corporateBrochure.form.industry.residence': 'Luxury Residences',
  'corporateBrochure.form.industry.finance': 'Finance',
  'corporateBrochure.form.industry.retail': 'Department Stores & Retail',
  'corporateBrochure.form.industry.luxurySales': 'Luxury Sales',
  'corporateBrochure.form.industry.clinic': 'Medical / Clinics',
  'corporateBrochure.form.industry.automotive': 'Automotive & Mobility',
  'corporateBrochure.form.industry.chauffeur': 'Chauffeur & Transfer',
  'corporateBrochure.form.industry.other': 'Other',
  'corporateBrochure.form.participants': 'Number of Participants',
  'corporateBrochure.form.participants.placeholder': 'e.g. 10 people',
  'corporateBrochure.form.format': 'Preferred Format',
  'corporateBrochure.form.format.select': 'Please select',
  'corporateBrochure.form.format.dispatch': 'On-Site (We travel to you)',
  'corporateBrochure.form.format.onsite': 'At Our Academy',
  'corporateBrochure.form.format.undecided': 'Undecided',
  'corporateBrochure.form.timeline': 'Timeline',
  'corporateBrochure.form.timeline.placeholder': 'e.g. Next month, this quarter, undecided',
  'corporateBrochure.form.message': 'Message (Optional)',
  'corporateBrochure.form.message.placeholder': 'Please describe your training goals, requirements, or any questions.',
  'corporateBrochure.form.message.error': 'Please limit to 500 characters',
  'corporateBrochure.form.required': 'Required',
  'corporateBrochure.form.optional': 'Optional',
  'corporateBrochure.form.privacyAgree': 'I agree to the',
  'corporateBrochure.form.privacy': 'Privacy Policy',
  'corporateBrochure.form.privacyError': 'You must agree to the Privacy Policy',
  'corporateBrochure.form.submit': 'Review This Request',

  // Confirm page
  'corporateBrochure.confirm.homeLink': 'Home',
  'corporateBrochure.confirm.corporateLink': 'Corporate Training',
  'corporateBrochure.confirm.brochureLink': 'Corporate Brochure Request',
  'corporateBrochure.confirm.currentPage': 'Confirm',
  'corporateBrochure.confirm.title': 'Confirm Your Corporate Brochure Request',
  'corporateBrochure.confirm.lead': 'If the details below are correct, please click "Submit".',
  'corporateBrochure.confirm.edit': 'Edit',
  'corporateBrochure.confirm.submit': 'Submit',
  'corporateBrochure.confirm.submitting': 'Submitting...',
  'corporateBrochure.confirm.error': 'Submission failed. Please try again, or call us at 03-6824-4086.',
  'corporateBrochure.confirm.networkError': 'A network error occurred. Please check your connection and try again.',
  'corporateBrochure.confirm.field.company': 'Company Name',
  'corporateBrochure.confirm.field.department': 'Department / Title',
  'corporateBrochure.confirm.field.name': 'Contact Person',
  'corporateBrochure.confirm.field.email': 'Email Address',
  'corporateBrochure.confirm.field.phone': 'Phone Number',
  'corporateBrochure.confirm.field.industry': 'Industry',
  'corporateBrochure.confirm.field.format': 'Preferred Format',
  'corporateBrochure.confirm.field.participants': 'Number of Participants',
  'corporateBrochure.confirm.field.timeline': 'Timeline',
  'corporateBrochure.confirm.field.message': 'Message',
  'corporateBrochure.confirm.field.privacy': 'Privacy Policy',
  'corporateBrochure.confirm.unspecified': '(not provided)',
  'corporateBrochure.confirm.agreed': 'Agreed',

  // Complete page
  'corporateBrochure.complete.title': 'Thank You for Your Request',
  'corporateBrochure.complete.lead1': 'A confirmation email has been sent to the email address you provided.',
  'corporateBrochure.complete.lead2': 'The corporate brochure will be sent by email. For any questions, please feel free to call us at 03-6824-4086 (weekdays 10:00-17:00).',
  'corporateBrochure.complete.corporateBtn': 'Corporate Training Page',
  'corporateBrochure.complete.homeBtn': 'Back to Home',

  // FAQSection
  'corporateBrochure.faq.label': 'FAQ',
  'corporateBrochure.faq.title': 'Frequently Asked Questions',
  'corporateBrochure.faq.subtitleEn': 'Frequently Asked Questions',
  'corporateBrochure.faq.0.q': 'What format will the brochure be sent in?',
  'corporateBrochure.faq.0.a': 'It will be sent by email as a PDF. If you would prefer postal delivery, please note this in the message field.',
  'corporateBrochure.faq.1.q': 'Will I receive sales calls just for requesting the brochure?',
  'corporateBrochure.faq.1.a': 'The brochure request is free, and we will not contact you excessively unless requested. Please feel free to reach out with any questions.',
  'corporateBrochure.faq.2.q': 'Is this different from the individual brochure request?',
  'corporateBrochure.faq.2.a': 'Yes, this is a dedicated brochure for our corporate on-site training programme. If you would like our individual butler training course brochure, please use the individual brochure request page.',

  // RelatedPages
  'corporateBrochure.related.label': 'RELATED',
  'corporateBrochure.related.title': 'Related Pages',
  'corporateBrochure.related.subtitleEn': 'See Also',
  'corporateBrochure.related.viewMore': 'Learn More',
  'corporateBrochure.related.0.title': 'About Corporate Training',
  'corporateBrochure.related.0.desc': 'Full overview of our on-site and academy-based training programmes and pricing',
  'corporateBrochure.related.1.title': 'Individual Brochure Request',
  'corporateBrochure.related.1.desc': 'Request our butler training course brochure',
  'corporateBrochure.related.2.title': 'Contact Us',
  'corporateBrochure.related.2.desc': 'Contact us by phone or email',
  'corporateBrochure.related.3.title': 'Consultation',
  'corporateBrochure.related.3.desc': 'Book an online individual consultation',

  // CTASection
  'corporateBrochure.cta.lead': 'If you would like to discuss details alongside the brochure, please visit our corporate training page or contact us.',
  'corporateBrochure.cta.corporateBtn': 'Corporate Training Page',
  'corporateBrochure.cta.contactBtn': 'Contact Us',
};

export default corporateBrochure;
